import { RESTRICTED_CONTENT_TYPES } from "@equidefi/shared";
import { merge } from "lodash";

import type { FileRejection } from "react-dropzone";

interface HandleRejectionFilesOptions {
  onReject?: (message: string) => void;
  maxFiles?: number;
  maxSize?: number;
}

export const DEFAULT_MAX_FILES = 1;
export const DEFAULT_MAX_SIZE = 1024 * 1024 * 25; // 25 MB

const DEFAULT_OPTIONS: HandleRejectionFilesOptions = {
  onReject: () => {},
  maxFiles: DEFAULT_MAX_FILES,
  maxSize: DEFAULT_MAX_SIZE,
};

export function handleRejectionFiles(
  rejectedFiles: FileRejection[],
  options: HandleRejectionFilesOptions = DEFAULT_OPTIONS,
) {
  const opts = merge({}, DEFAULT_OPTIONS, options);
  for (const rejectedFile of rejectedFiles) {
    let error = null;

    const errorCodes = rejectedFiles.flatMap((file) => file.errors.map((e) => e.code));

    if (errorCodes.includes("file-invalid-types") || errorCodes.includes("file-invalid-type")) {
      const extension = rejectedFile.file.name.split(".").pop();
      error = `You cannot upload a ".${extension}" file type, please upload one of these supported types: ${Object.keys(
        RESTRICTED_CONTENT_TYPES,
      ).join(", ")}`;
    } else if (errorCodes.includes("too-many-files")) {
      error = `You can only upload ${opts.maxFiles} files at a time.`;
    } else if (errorCodes.includes("file-too-large")) {
      error = `You can only upload documents less than ${(opts.maxSize / (1024 * 1024)).toFixed(0)}MB.`;
    }

    if (error !== null) {
      opts?.onReject?.(error);
      return true;
    }
  }

  return false;
}
